// extracted by mini-css-extract-plugin
var _1 = "LineVerticalComponent_content__8f8f5";
export { _1 as "content" }
